import React from 'react';
import { motion } from 'framer-motion';
import { HammerIcon, UsersIcon, ShieldCheckIcon, HeartHandshakeIcon } from 'lucide-react';
import { Emblem } from './Emblem';
const pillars = [{
  icon: HammerIcon,
  title: 'Made on a bench you can see from the doorway',
  body: "We don't outsource. Every ring, every repair, every restoration is designed and crafted in our Ardross workshop — usually by James or a jeweller he's trained personally."
}, {
  icon: UsersIcon,
  title: 'Three generations of the same family',
  body: "Started by James's grandfather in 1947. Most of our customers have been with us for decades. Some are now bringing in their grandchildren's engagement rings."
}, {
  icon: ShieldCheckIcon,
  title: 'A firm written quote, before any work begins',
  body: "You'll know exactly what your piece will cost, how long it will take, and what it will look like — before we touch a single tool. No surprises. Ever."
}, {
  icon: HeartHandshakeIcon,
  title: 'Lifetime care for the pieces we make',
  body: "Every Sinclairs-made piece comes with complimentary inspections, cleanings, and adjustments — for as long as you wear it. That's not a marketing line. It's just what family jewellers do."
}];
export function WhySinclairs() {
  return <section className="section-padding bg-primary text-white relative overflow-hidden" data-id="element-598">
      <div className="absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: 'radial-gradient(var(--color-gold-light) 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-599" />

      <div className="container-custom relative z-10" data-id="element-600">
        <div className="flex items-start justify-between gap-10 mb-14 flex-wrap" data-id="element-601">
          <div className="max-w-3xl" data-id="element-602">
            <span className="eyebrow-light" data-id="element-603">Why Perth Families Stay</span>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-[2.75rem] font-medium leading-[1.1] text-white text-balance" data-id="element-604">
              Four reasons families who've trusted us for thirty years{' '}
              <span className="italic text-gold-light" data-id="element-605">
                still walk through our door.
              </span>
            </h2>
          </div>
          <Emblem size={60} className="text-gold/40 hidden lg:block shrink-0" data-id="element-606" />
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10" data-id="element-607">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.08
        }} className="bg-primary p-8 md:p-10 group hover:bg-navy transition-colors" data-id="element-608">
              <pillar.icon className="w-7 h-7 text-gold-light mb-6" strokeWidth={1.25} data-id="element-609" />
              <h3 className="font-serif text-xl md:text-2xl text-white mb-3 leading-snug" data-id="element-610">
                {pillar.title}
              </h3>
              <p className="text-sm md:text-base text-white/70 leading-relaxed text-pretty" data-id="element-611">
                {pillar.body}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}